(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-cta"] && !Shopify.designMode) return;
  try {
    (function () {
    var sticky = document.getElementById('sticky-cta');
    if (!sticky) return;

    // Cache both references once — no repeated DOM queries per scroll tick.
    var wrapper = document.querySelector('.page-wrapper');
    var scrollThreshold = 300;
    var ticking = false;

    // This theme only scrolls a dedicated ".page-wrapper" container on
    // desktop (min-width: 990px, used for page-transition animations —
    // see assets/base.css). Below that breakpoint, ".page-wrapper" has
    // no overflow of its own and the window/html scrolls normally
    // instead. Taking the larger of the two values correctly covers
    // whichever mechanism is actually active at the current viewport.
    function currentScrollY() {
      var wrapperScroll = wrapper ? wrapper.scrollTop : 0;
      var windowScroll = window.scrollY || document.documentElement.scrollTop || 0;
      return Math.max(wrapperScroll, windowScroll);
    }

    function applyVisibility() {
      sticky.classList.toggle('is-visible', currentScrollY() > scrollThreshold);
      ticking = false;
    }

    // A single capture-phase listener on document is both necessary and
    // sufficient: capture is required because ".page-wrapper"'s own
    // scroll event doesn't bubble (so a plain window/document bubble
    // listener would never see it), and the same listener also catches
    // ordinary window/document scrolling on mobile. A separate
    // window-level listener would just fire a second time for the same
    // scroll on mobile, doing duplicate work.
    //
    // We filter to only the main wrapper or window/document, so
    // scrolling inside drawers, modals, or image galleries — which have
    // their own internal scroll — doesn't incorrectly toggle this button.
    //
    // requestAnimationFrame throttles the actual class toggle to once
    // per frame, since 'scroll' can fire far more often than the
    // browser can usefully repaint.
    document.addEventListener(
      'scroll',
      function (e) {
        var target = e.target;
        var isMainScroll = target === document || target === window || target === wrapper;
        if (!isMainScroll || ticking) return;
        ticking = true;
        requestAnimationFrame(applyVisibility);
      },
      { passive: true, capture: true }
    );

    applyVisibility();
  })();
  } catch(e) { console.error(e); }
})();

})();
